import { Box, Typography } from '@mui/material';
import WizardBackButton from 'pages/GettingStarted/Wizard/components/WizardBackLink';
import {
	WIZARD_CHECKLIST_ITEM_DONE,
	WIZARD_CHECKLIST_SECTION,
	WIZARD_PAGES
} from 'pages/GettingStarted/Wizard/utils/consts';
import React, { FC } from 'react';
import {
	IWizardChecklistSection,
	IWizardProps,
	WizardPhase
} from 'types/wizard';

import { goConfetti } from '@utils/confeti';
import { cloneDeep } from 'lodash';
import WizardCheckListSection from 'pages/GettingStarted/Wizard/components/WizardChecklistSection';
import WizardContentLayout from 'pages/GettingStarted/Wizard/Phases/WizardContentLayout';
import { useWizardUpdate } from '../../utils/hook';

const ChecklistPage: FC<IWizardProps> = (props) => {
	const { state } = props;
	const { checklist } = state;

	const { update } = useWizardUpdate(state);

	const handleBack = React.useCallback(() => {
		update({
			phase: WizardPhase.Integrate,
			page: WIZARD_PAGES.preview
		});
	}, [update]);

	const handleItemChanged = React.useCallback(
		async (newSection: IWizardChecklistSection) => {
			const newChecklist = cloneDeep(checklist) || {};
			newChecklist[newSection.name] = newSection;

			const checklistDone = Object.values(newChecklist).every((section) =>
				section.items.every(
					(item) => item.status === WIZARD_CHECKLIST_ITEM_DONE
				)
			);

			if (checklistDone) {
				goConfetti();
			}
			await update({
				checklist: newChecklist,
				phase: checklistDone ? WizardPhase.Done : WizardPhase.Customize
			});
		},
		[checklist, update]
	);

	const sectionProps = {
		onItemChanged: handleItemChanged,
		...props
	};

	return (
		<WizardContentLayout
			{...{ state }}
			backButton={null}
			actionButton={<WizardBackButton onClick={handleBack} />}
		>
			<Box display="flex" flexDirection="column">
				<Typography variant="h6">
					{intl.tr('wizard.phase.customize.checklist.header')}
				</Typography>
				<Typography variant="body1">
					{intl.tr('wizard.phase.customize.checklist.subtitle')}
				</Typography>
				<Box pt={3} />
				<WizardCheckListSection
					name={WIZARD_CHECKLIST_SECTION.customize}
					{...sectionProps}
				/>
				<Box pb={2} />
				<WizardCheckListSection
					name={WIZARD_CHECKLIST_SECTION.initialSetup}
					{...sectionProps}
				/>
				<Box pb={2} />
				<WizardCheckListSection
					name={WIZARD_CHECKLIST_SECTION.share}
					{...sectionProps}
				/>
			</Box>
		</WizardContentLayout>
	);
};

export default ChecklistPage;
